import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
// api gére les requetes vers l'api avec axios et la variable d'environnement;
import api from "../api";
import UseTitle from "../components/useTitle";
import "./Addxp.scss";

const Addxp = () => {
  // Définition du titre de la page
  UseTitle("Ajouter de l'expérience");

  const [listCharacters, setListCharacters] = useState([]);
  const [charactersXP, setCharactersXP] = useState({});
  const [charactersSelected, setCharactersSelected] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [redirectTo, setRedirectTo] = useState();
  const [checkButton, setCheckButton] = useState(false);
  const [minXPSelected, setMinXPSelected] = useState(0);

  const handleAddXP = () => {
    // TODO : Ajouter les vérifications (xp vide, ...)
    setIsLoading(true);
    api
      .post("/addxp/", charactersXP)
      .then((response) => {
        setRedirectTo("/characters");
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleXPChange = (characterId, xp) => {
    // si on retire de l'expérience
    if (xp < 0) {
      if (charactersXP[characterId] === undefined) return;
      if (charactersXP[characterId] + xp < 0) {
        setCharactersXP({ ...charactersXP, [characterId]: 0 });
      } else {
        setCharactersXP({
          ...charactersXP,
          [characterId]: charactersXP[characterId] + xp,
        });
      }
      // si on ajoute de l'expérience
    } else {
      if (charactersXP[characterId] === undefined) {
        setCharactersXP({ ...charactersXP, [characterId]: xp });
      } else {
        setCharactersXP({
          ...charactersXP,
          [characterId]: charactersXP[characterId] + xp,
        });
      }
    }
  };

  const handleSelectCharacter = (characterId) => {
    if (charactersSelected.includes(characterId)) {
      setCharactersSelected(
        charactersSelected.filter((id) => id !== characterId)
      );
    } else {
      setCharactersSelected([...charactersSelected, characterId]);
    }
  };

  const handleSelectAllCharacters = () => {
    if (charactersSelected.length === listCharacters.length) {
      setCharactersSelected([]);
    } else {
      setCharactersSelected(listCharacters.map((character) => character.id));
    }
  };

  const handleXPChangeSelectedCharacters = (xp) => {
    setCharactersXP((prevState) => {
      const newXP = { ...prevState };
      charactersSelected.forEach((characterId) => {
        newXP[characterId] = (newXP[characterId] || 0) + xp;
        if (newXP[characterId] <= 0) {
          delete newXP[characterId];
        }
      });
      return newXP;
    });
  };

  useEffect(() => {
    api
      .get("/character/?ordering=name&page_size=9999")
      .then((response) => {
        setListCharacters(response.data.results);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    for (const id in charactersXP) {
      if (charactersXP[id] <= 0) {
        delete charactersXP[id];
      }
    }
    if (Object.keys(charactersXP).length > 0) {
      setCheckButton(true);
    } else {
      setCheckButton(false);
    }
  }, [charactersXP]);

  useEffect(() => {
    if (charactersSelected.length > 0) {
      const minXP = Math.min(
        ...charactersSelected.map((id) =>
          charactersXP[id] !== undefined ? charactersXP[id] : 0
        )
      );
      setMinXPSelected(minXP);
    } else {
      setMinXPSelected(0);
    }
  }, [charactersSelected, charactersXP]);

  if (redirectTo) {
    return <Navigate to={redirectTo} />;
  }

  return (
    <div className="add-xp">
      {isLoading && (
        <div className="loading-data">
          <div className="loading-spinner"></div>
          <div className="loading-text">Chargement...</div>
        </div>
      )}
      {!isLoading && listCharacters.length === 0 && <p>Pas de personnage</p>}
      {!isLoading && listCharacters.length > 0 && (
        <>
          <h1>Ajouter des points d'expérience</h1>
          <p>
            Choisissez les personnages à qui ajouter des points d'expérience
          </p>
          <div className="list-add">
            <div className="add select">
              <span className="selected">
                <input
                  type="checkbox"
                  id="selected"
                  checked={listCharacters.length === charactersSelected.length}
                  onChange={handleSelectAllCharacters}
                />
                <label htmlFor="selected">Sélectionné(s)</label>
              </span>
              <div className="buttons">
                <button
                  className={minXPSelected < 5 ? "bt disabled" : "bt"}
                  disabled={minXPSelected < 5}
                  onClick={() => handleXPChangeSelectedCharacters(-5)}
                >
                  -5
                </button>
                <button
                  className={minXPSelected < 10 ? "bt disabled" : "bt"}
                  disabled={minXPSelected < 10}
                  onClick={() => handleXPChangeSelectedCharacters(-10)}
                >
                  -10
                </button>
                <button
                  className={
                    charactersSelected.length === 0 ? "bt disabled" : "bt"
                  }
                  disabled={charactersSelected.length === 0}
                  onClick={() => handleXPChangeSelectedCharacters(10)}
                >
                  +10
                </button>
                <button
                  className={
                    charactersSelected.length === 0 ? "bt disabled" : "bt"
                  }
                  disabled={charactersSelected.length === 0}
                  onClick={() => handleXPChangeSelectedCharacters(5)}
                >
                  +5
                </button>
              </div>
            </div>
            {listCharacters.map((character) => (
              <div className="add" key={character.id}>
                <span className="character">
                  <input
                    type="checkbox"
                    id={`character-${character.id}`}
                    checked={charactersSelected.includes(character.id)}
                    onChange={() => handleSelectCharacter(character.id)}
                  />
                  <label className="name" htmlFor={`character-${character.id}`}>
                    {character.name}{" "}
                    <small>({character.user_proprietary})</small>
                  </label>
                  <span className="xp">{charactersXP[character.id] || 0}</span>
                </span>
                <div className="buttons">
                  <button
                    className={
                      charactersXP[character.id] === undefined ||
                      charactersXP[character.id] < 5
                        ? "bt disabled"
                        : "bt"
                    }
                    disabled={
                      charactersXP[character.id] === undefined ||
                      charactersXP[character.id] < 5
                    }
                    onClick={() => handleXPChange(character.id, -5)}
                  >
                    -5
                  </button>
                  <button
                    className={
                      charactersXP[character.id] === undefined ||
                      charactersXP[character.id] < 10
                        ? "bt disabled"
                        : "bt"
                    }
                    disabled={
                      charactersXP[character.id] === undefined ||
                      charactersXP[character.id] < 10
                    }
                    onClick={() => handleXPChange(character.id, -10)}
                  >
                    -10
                  </button>
                  <button
                    className="bt"
                    onClick={() => handleXPChange(character.id, 10)}
                  >
                    +10
                  </button>
                  <button
                    className="bt"
                    onClick={() => handleXPChange(character.id, 5)}
                  >
                    +5
                  </button>
                </div>
              </div>
            ))}
          </div>

          <button
            className={checkButton ? "bt" : "bt disabled"}
            disabled={!checkButton}
            onClick={handleAddXP}
          >
            Ajouter XP
          </button>
        </>
      )}
    </div>
  );
};

export default Addxp;
